import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const ErrorPage = ({ error }) => {
    // TODO: report error to the backend for monitoring
    return (_jsxs("div", { role: 'alert', children: [_jsx("p", { children: "An error occurred" }), _jsx("pre", { style: { color: 'red' }, children: error === null || error === void 0 ? void 0 : error.message })] }));
};
